import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-date',
    template: `
@if (visible) {
  <mat-form-field class="demo-full-width margin-top" [formGroup]="group" appearance="outline">
    <mat-label> {{ field.label }} </mat-label>
    <input matInput [matDatepicker]="picker" [formControlName]="field.key" [placeholder]="field.label"  [min]="field.minDate || null" [max]="field.maxDate || null" readonly>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-hint align="start"><strong>{{field.hint}}</strong> </mat-hint>
    @for (validation of field.validations; track validation) {
      <ng-container ngProjectAs="mat-error">
        @if (group.get(field.key).hasError(validation.name)) {
          <mat-error>{{validation.message}}</mat-error>
        }
      </ng-container>
    }
  </mat-form-field>
}
`,
    // host: {'class': 'col-md-6'},
    styles: [],
    standalone: false
})
export class DateComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  visible = true;
  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() { }
  ngOnInit() {
    // this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
  }
}
